












import {Component, Mixins, Watch} from 'vue-property-decorator';

import {IsMeetingsEnabled} from "@mixins/isMeetingsEnabled";
import AnalyticsMixin from "@mixins/AnalyticsMixin";

import ProgramRoot from "@share/program/ProgramRoot.vue";
import StageController from "./stage-controller/StageController.vue";
import { ProgramDataHelper } from '@share/program/helpers/ProgramDataHelper';
import { DateTime } from 'luxon';
import { getBackend } from '@service/router/getters';
import { Element } from '@api/models/Element';
import { setTimeout } from 'timers';

@Component({
    name: 'Stage',
    components: { ProgramRoot, StageController }
})
export default class Stage extends Mixins(AnalyticsMixin, IsMeetingsEnabled) {

    created() {
        this.wAllAgendas(this.allAgendas || [], false)
    }

    @Watch("allAgendas")
    wAllAgendas(agendas: Element[], withDelay: boolean | any) {

        const filteringByTagAllowed = this.$store.getters['events/selectedEventViewParam']('stage', null)?.useFilteringSessionsByTags;

        if(!filteringByTagAllowed) {return;}

        let delay = 0;

        if(typeof withDelay === "boolean" && withDelay || typeof withDelay !== "boolean") {
            delay = Math.round(Math.random() * 9000);
        }

        const tagsIds = new Set(agendas.map(agenda => agenda.tagsIds || '').filter(tagId => tagId).flat()).values();

        setTimeout(() => {
            this.$store.dispatch("tags/loadSessionTags", Array.from(tagsIds))
        }, delay)
    }

    get allAgendas() {
        return this.dataHelper?.allAgendas || [];
    }

    get eventId(): string {
        return this.$store.state.events.selected;
    }

    get backend() {
        return getBackend(this.$route.params.backend)
    }

    /**
     * Data helper for data manipulation, comes from vuex store by date
     */
    get dataHelper(): ProgramDataHelper | null {
        return this.$store.state.program.programs[this.$store.getters["program/currentDateString"]]
    }

    get isOnEdit() {
        return this.$store.state.isOnEditing;
    }

}
